import { API_BASE_URL } from "../config/apiBase";

const KEY = "writeflow_admin_student_view";
let originalFetch;

export function storedStudentView() {
  try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); }
  catch { return null; }
}

export function getStudentView() {
  const view = storedStudentView();
  return view && window.location.pathname.startsWith("/student/") ? view : null;
}

export function isStudentView() { return Boolean(getStudentView()); }

export async function startStudentView(studentId, returnTo) {
  const response = await fetch(`${API_BASE_URL}/api/admin/student-view/${encodeURIComponent(studentId)}`, {
    method: "POST", headers: { "X-User": localStorage.getItem("student_id") || "" },
  });
  const data = await response.json();
  if (!response.ok) throw new Error(data.detail || "Could not open student view.");
  // This is tab-local viewing state. Admin authentication is never replaced.
  sessionStorage.setItem(KEY, JSON.stringify({ ...data, returnTo }));
  return data;
}

export async function exitStudentView() {
  const view = storedStudentView();
  if (!view) return "/admin/users";
  try {
    await fetch(`${API_BASE_URL}/api/admin/student-view`, {
      method: "DELETE", headers: { "X-User": view.actor_id, "X-Student-View": view.token },
    });
  } finally {
    sessionStorage.removeItem(KEY);
  }
  return view.returnTo || "/admin/users";
}

export function installStudentViewTransport() {
  if (originalFetch || typeof window.fetch !== "function") return;
  originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const view = getStudentView();
    const url = new URL(typeof input === "string" ? input : input.url, window.location.origin);
    const base = new URL(API_BASE_URL, window.location.origin);
    const method = String(init.method || input?.method || "GET").toUpperCase();
    const isApi = url.origin === base.origin && url.pathname.startsWith(base.pathname.replace(/\/$/, "") + "/");
    const isExit = url.pathname === "/api/admin/student-view" && method === "DELETE";
    if (!view || !isApi || isExit || url.pathname === "/api/auth/me") return originalFetch(input, init);
    if (method !== "GET" || view.expires_at * 1000 <= Date.now()) {
      return new Response(JSON.stringify({ detail: "Student view is read-only. Exit the view to make changes." }), {
        status: 403, headers: { "Content-Type": "application/json" },
      });
    }
    const headers = new Headers(init.headers || input?.headers);
    headers.set("X-User", view.actor_id);
    headers.set("X-Student-View", view.token);
    url.searchParams.delete("dev_jump");
    url.searchParams.delete("force_recompute");
    const nextInput = typeof input === "string" ? url.href : new Request(url.href, input);
    return originalFetch(nextInput, { ...init, headers, cache: "no-store" });
  };
}
